module.exports = __webpack_public_path__ + "img/CT.Tunnels.Tunnel_Lining.Primary_and_Secondary_Lining_(SFRC_and_Rebar).Reinforced_Concrete.48b6e43d.png";